export default "__VITE_ASSET__e1073d1d__"